// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-metrics-summary-panel {
  margin-top: -0.85rem;
}

.report-metrics-summary-content {
  padding-top: 0.5rem;
}

.report-metrics-summary-section {
  margin-bottom: 1rem;
}

.report-metrics-summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e2e8f0;
}

.dark .report-metrics-summary-row {
  border-bottom-color: #374151;
}

.report-metrics-summary-row--last {
  border-bottom: none;
}

/* The section owns the grid so every row shares one label track and the values
   all begin at the same x, instead of each row right-aligning its own value. */
.report-metrics-summary-section--undivided {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, max-content);
  align-items: center;
  column-gap: 0.75rem;
  row-gap: 1rem;
  padding: 0.5rem 0;
}

.report-metrics-summary-section--undivided .report-metrics-summary-row {
  display: contents;
  border-bottom: none;
}

.report-metrics-summary-label {
  color: #64748b;
}

.dark .report-metrics-summary-label {
  color: #9ca3af;
}

.report-metrics-summary-value {
  color: #1d4ed8;
  font-weight: 600;
}

.dark .report-metrics-summary-value {
  color: #93c5fd;
}
`, "",{"version":3,"sources":["webpack://./src/components/report/ReportFullSessionMetricsSummary.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;+EAC+E;AAC/E;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".report-metrics-summary-panel {\n  margin-top: -0.85rem;\n}\n\n.report-metrics-summary-content {\n  padding-top: 0.5rem;\n}\n\n.report-metrics-summary-section {\n  margin-bottom: 1rem;\n}\n\n.report-metrics-summary-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dark .report-metrics-summary-row {\n  border-bottom-color: #374151;\n}\n\n.report-metrics-summary-row--last {\n  border-bottom: none;\n}\n\n/* The section owns the grid so every row shares one label track and the values\n   all begin at the same x, instead of each row right-aligning its own value. */\n.report-metrics-summary-section--undivided {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, max-content);\n  align-items: center;\n  column-gap: 0.75rem;\n  row-gap: 1rem;\n  padding: 0.5rem 0;\n}\n\n.report-metrics-summary-section--undivided .report-metrics-summary-row {\n  display: contents;\n  border-bottom: none;\n}\n\n.report-metrics-summary-label {\n  color: #64748b;\n}\n\n.dark .report-metrics-summary-label {\n  color: #9ca3af;\n}\n\n.report-metrics-summary-value {\n  color: #1d4ed8;\n  font-weight: 600;\n}\n\n.dark .report-metrics-summary-value {\n  color: #93c5fd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
